
  var _styles = {
  "reward-records-header-t": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.37333rem",
    "marginBottom": "0.33333rem",
    "width": "10rem",
    "position": "relative",
    "height": "0.74453rem"
  },
  "reward-records-tabs-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": 0,
    "marginRight": "auto",
    "marginBottom": "0.29333rem",
    "marginLeft": "auto",
    "height": "1.06667rem",
    "width": "9.09333rem",
    "borderRadius": "0.53333rem",
    "backgroundColor": "rgb(231,231,231)",
    "padding": "0.05333rem"
  },
  "reward-records-tabs-item": {
    "width": "4.44rem",
    "flex": 1,
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "0.96rem",
    "borderRadius": "0.48rem"
  },
  "reward-records-tabs-item-active": {
    "backgroundColor": "rgb(255,255,255)"
  },
  "reward-records-tabs-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "fontWeight": "600",
    "lineHeight": "0.53333rem",
    "color": "rgb(17,17,17)",
    "textAlign": "center"
  },
  "reward-tabs-item": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "1.70667rem",
    "height": "0.73333rem"
  },
  "tab-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.42667rem",
    "lineHeight": "0.6rem",
    "textAlign": "center",
    "color": "rgb(255,255,255)"
  },
  "reward-tabactive_tab-text": {
    "fontWeight": "600",
    "opacity": 1
  },
  "tab-indicator": {
    "width": "0.85333rem",
    "height": "0.10667rem",
    "backgroundColor": "rgb(255,242,4)",
    "borderRadius": "0.05333rem",
    "marginTop": "0.02667rem"
  },
  "free-card-indicator": {
    "left": "2.68rem"
  },
  "points-indicator": {
    "left": "6.46667rem"
  },
  "activity-time-container": {
    "marginBottom": "0.32rem",
    "paddingTop": 0,
    "paddingRight": "0.42667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.42667rem"
  },
  "activity-time-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "fontWeight": "400",
    "lineHeight": "0.45333rem",
    "color": "rgb(153,153,153)"
  },
  "reward-records-content": {
    "width": "10rem",
    "paddingTop": 0,
    "paddingRight": "0.42667rem",
    "paddingBottom": "0.42667rem",
    "paddingLeft": "0.42667rem"
  },
  "loading-container": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "height": "1.33333rem",
    "width": "100%"
  },
  "loading-text": {
    "color": "rgb(255,255,255)",
    "fontSize": "0.37333rem"
  },
  "exchange-reward-item": {
    "display": "flex",
    "boxSizing": "border-box",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(9,116,205)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.66667rem",
    "paddingRight": "0.48rem",
    "paddingBottom": "0.66667rem",
    "paddingLeft": "0.48rem",
    "marginBottom": "0.32rem",
    "height": "2.12rem"
  },
  "exchange-content": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center"
  },
  "exchange-title": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.46667rem"
  },
  "exchange-subtitle": {
    "color": "rgb(169,216,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.34667rem"
  },
  "exchange-button": {
    "width": "2.2rem",
    "height": "0.8rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "exchange-button-text": {
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "0.52rem"
  },
  "free-card-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.66667rem",
    "paddingRight": "0.48rem",
    "paddingBottom": "0.66667rem",
    "paddingLeft": "0.48rem",
    "marginBottom": "0.32rem",
    "height": "2.12rem"
  },
  "free-card-content": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center"
  },
  "free-card-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.46667rem",
    "marginTop": "0.08rem",
    "marginBottom": "0.08rem"
  },
  "free-card-subtitle": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.29333rem"
  },
  "use-button": {
    "width": "2.2rem",
    "height": "0.8rem",
    "borderRadius": "7.45333rem",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "use-button-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "lineHeight": "0.52rem"
  },
  "hotel-reward-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.58667rem",
    "paddingRight": "0.54667rem",
    "paddingBottom": "0.48rem",
    "paddingLeft": "0.48rem",
    "height": "2.12rem"
  },
  "hotel-reward-left": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center"
  },
  "hotel-reward-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem",
    "maxWidth": "4.97333rem"
  },
  "hotel-reward-subtitle": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem"
  },
  "hotel-reward-tag-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "marginTop": "0.10667rem"
  },
  "hotel-reward-tag": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "height": "0.45333rem",
    "position": "relative",
    "zIndex": 1,
    "marginRight": "0.10667rem"
  },
  "tag-free-text": {
    "width": "0.45333rem",
    "height": "0.45333rem",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center"
  },
  "tag-detail": {
    "backgroundColor": "rgb(255,241,240)",
    "borderTopRightRadius": "0.16rem",
    "borderBottomRightRadius": "0.16rem",
    "borderTopLeftRadius": 0,
    "borderBottomLeftRadius": 0,
    "paddingTop": 0,
    "paddingRight": "0.10667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.18667rem",
    "height": "0.45333rem",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "tag-detail-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.45333rem",
    "textAlign": "center"
  },
  "hotel-reward-right": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "2.06667rem"
  },
  "hotel-reward-amount": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "amount-symbol": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.45333rem",
    "marginRight": "0.02667rem"
  },
  "amount-value": {
    "color": "rgb(255,45,25)",
    "fontSize": "0.61333rem",
    "lineHeight": "0.66667rem"
  },
  "hotel-reward-status": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.32rem",
    "textAlign": "center"
  },
  "hotel-reward-statuspending": {
    "color": "rgb(255,255,255)"
  },
  "hotel-reward-statuscompleted": {
    "color": "rgb(255,255,255)"
  },
  "reward-group": {
    "marginBottom": "0.53333rem"
  },
  "group-period": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.37333rem",
    "marginBottom": "0.32rem"
  },
  "reward-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(9,116,205)",
    "borderRadius": "0.32rem",
    "paddingTop": "0.66667rem",
    "paddingRight": "0.48rem",
    "paddingBottom": "0.66667rem",
    "paddingLeft": "0.48rem",
    "height": "2.12rem"
  },
  "reward-item-left": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center"
  },
  "reward-item-title": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem"
  },
  "reward-item-time": {
    "color": "rgb(169,216,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.34667rem"
  },
  "reward-item-right": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-end"
  },
  "reward-item-amount": {
    "color": "rgb(251,255,15)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem",
    "textAlign": "right"
  },
  "reward-item-description": {
    "color": "rgb(169,216,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.34667rem",
    "textAlign": "right"
  },
  "call-record-item": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.32rem",
    "padding": "0.48rem",
    "height": "1.92rem",
    "width": "9.14667rem",
    "boxSizing": "border-box"
  },
  "call-record-left": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "flex": 1
  },
  "call-record-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "marginBottom": "0.16rem"
  },
  "call-record-time": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem"
  },
  "call-record-right": {
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "center",
    "alignItems": "flex-end"
  },
  "call-record-amount": {
    "color": "rgb(255,45,25)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.56rem",
    "marginBottom": "0.05333rem"
  },
  "call-record-desc": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "0.45333rem"
  }
};



  module.exports = _styles;
  